import {
  ActionReducerMap,
  ActionReducer,
  MetaReducer,
  Store
} from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { environment } from '../environments/environment';
import * as fromRootReducer from './reducer.root';
import * as notesReducer from './shared/common/components/notes/reducer';

/**
 * As mentioned, we treat each reducer like a table in a database. This means
 * our top level state interface is just a map of keys to inner state types.
 */
export interface State {
  notes: notesReducer.State;
  root: fromRootReducer.State;
  routerReducer: fromRouter.RouterReducerState;
}

/**
 * Our state is composed of a map of action reducer functions.
 * These reducer functions are called with each dispatched action
 * and the current or initial state and return a new immutable state.
 */
export const reducers: ActionReducerMap<State> = {
  notes: notesReducer.reducer,
  root: fromRootReducer.reducer,
  routerReducer: fromRouter.routerReducer
};

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
  return function (state: State, action: any): State {

    // TODO: Verify this method is necessary.  It was logging
    // ALL actions to the console, exposing the state of the application
    // to anyone at all times.  Logging was removed, but method will remain
    // to prevent any breakage.

    return reducer(state, action);
  };
}

export function getValue<T>(stream$: Observable<T>): T {
  let result: T;
  stream$.pipe(take(1)).subscribe(value => result = value);
  return result;
}

/**
 * By default, @ngrx/store uses combineReducers with the reducer map to compose
 * the root meta-reducer. To add more meta-reducers, provide an array of meta-reducers
 * that will be composed to form the root meta-reducer.
 */
export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [logger]
  : [];

export function getState(store: Store<State>): State {
  let state: State;
  store.pipe(take(1)).subscribe(s => state = s);
  return state;
}
